module.exports = __webpack_public_path__ + "img/vertical_layout_2.54f5e24d.jpg";